import clsx from "clsx";
import {JSXConverters} from "@payloadcms/richtext-lexical/react";
import {SerializedHeadingNode} from "@payloadcms/richtext-lexical";

export const headingConverter = (theme?: "light" | "dark"): JSXConverters<SerializedHeadingNode> => ({

    heading: ({ node, nodesToJSX }) => {

        const text = nodesToJSX({ nodes: node.children });
        const joinedText = text.join('');
        const Tag = node.tag as keyof JSX.IntrinsicElements;

        const baseStyles = "font-jost m-0 leading-tight tracking-tight font-semibold wrap-break-word";

        const isLight = theme === "light";

        let className = "";

        switch (node.tag) {
            case 'h1':
                className = clsx(baseStyles, "py-5 text-3xl md:text-5xl md:leading-snug! text-center", isLight ? "text-grass-500" : "text-white");
                break;
            case 'h2':
                className = clsx(baseStyles, "py-5 text-3xl md:text-4xl uppercase text-zinc-900");
                break;
            case 'h3':
                className = clsx(baseStyles, "py-4 text-2xl md:text-3xl", isLight ? "text-grass-500" : "text-white");
                break;
            case 'h4':
                className = clsx(baseStyles, "py-4 text-xl font-bold uppercase text-zinc-900");
                break;
            case 'h5':
                className = clsx(baseStyles, "py-4 text-lg font-bold", isLight ? "text-grass-500" : "text-white");
                break;
            case 'h6':
                className = clsx(baseStyles, "py-4 text-base font-bold uppercase text-zinc-700");
                break;
        }

        const id = joinedText.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

        // @ts-ignore
        return <Tag id={id} className={className}>{text}</Tag>;

    }

});